import { ConfigProvider } from "melco-ui";
import { SelectField } from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { DataMappingAttribute } from "../../hooks/inputFormats/useDataMappings";
import { useColorCollectionsDropdownData } from "../../hooks/libraries/colorCollections/useColorCollectionsDropdown";

type SelectColorCollectionProps = {
  attribute: DataMappingAttribute;
};

export const SelectColorCollection: React.FC<SelectColorCollectionProps> = ({
  attribute,
}) => {
  const { t } = useTranslation();

  const { isLoading, isFetching, data, isPreviousData } =
    useColorCollectionsDropdownData();

  const colorCollectionOptions = (data ?? []).map((o) => ({
    value: o.id ?? "",
    label: o.name ?? "",
  }));

  return (
    <ConfigProvider
      renderEmpty={() => <>{t("color_collections_list.empty")}</>}
    >
      <SelectField
        name={`${attribute}.colorCollection`}
        label={t("dataMappings.form.label.colorCollection")}
        loading={isPreviousData ? isFetching : isLoading}
        style={{ width: "100%" }}
        options={colorCollectionOptions}
        showSearch
        optionFilterProp="label"
        filterOption
        allowClear
        placeholder={t("global.fallback.none")}
        info={t("libraries.color_collections.detail.form.embroideryWarning")}
      />
    </ConfigProvider>
  );
};
